import { Injectable, inject, signal } from '@angular/core';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { McpAccessLevel, mcpAccessLevelFromFlags } from 'mbs-ui-shared@models/McpAccessLevel.enum';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class McpSettingsService {
  private readonly auth = inject(AuthFacade);

  private readonly level = signal<McpAccessLevel>(McpAccessLevel.ReadOnly);
  private loaded = false;

  public readonly globalLevel = this.level.asReadonly();
  public load(): void {
    if (this.loaded) return;

    this.loaded = true;
    this.auth.currentUser$
      .pipe(filter((user) => !!user?.ProviderInfo))
      .subscribe(({ ProviderInfo }) => this.level.set(mcpAccessLevelFromFlags(ProviderInfo.McpReadAccess, ProviderInfo.McpFullAccess)));
  }

  public setGlobalLevel(level: McpAccessLevel): void {
    this.level.set(level);
  }
}
